import React from 'react';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import { LIST_VIEW, GRID_VIEW } from '../constants/viewTypes';
import { toggleView } from '../actions';

import ActionViewList from 'material-ui/svg-icons/action/view-list';
import ActionViewModule from 'material-ui/svg-icons/action/view-module';

const handleViewToggle = (props) => {
  props.dispatch(toggleView(props.view));
};

function ViewToggle(props) {
  const { currentViews } = props;

  return (
    <div>
      <IconButton
        onTouchTap={handleViewToggle.bind(this, props)}
        disabled={currentViews.get(props.view) === LIST_VIEW }
      ><ActionViewList /></IconButton>
      <IconButton
        onTouchTap={handleViewToggle.bind(this, props)}
        disabled={currentViews.get(props.view) === GRID_VIEW }
      ><ActionViewModule /></IconButton>
    </div>
  );
};

ViewToggle.propTypes = {
  view: React.PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    currentViews: state.get('viewState'),
  };
};

export default connect(mapStateToProps)(ViewToggle);



/** WEBPACK FOOTER **
 ** ./components/ViewToggle.js
 **/